import { LabeledValue } from "@msys/ui";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useFormikContext } from "formik";
import { get } from "lodash-es";
import moment from "moment";
import { FC } from "react";
import { CheckboxField } from "./CheckboxField.js";
import { TimePickerField } from "./TimePickerField.js";

interface Props {
  label?: string;
  name: string;
  disabled?: boolean;
}

export const OpeningHoursField: FC<Props> = ({ disabled, label, name }) => {
  const { t } = useTranslate("OpeningHoursField");
  const { values, setFieldValue } = useFormikContext<Record<string, any>>();

  return (
    <Box>
      <LabeledValue label={label ?? t("Opening hours")} />
      <Grid container columns={4} spacing={1 / 2}>
        {Array(7)
          .fill(null)
          .map((v, index) => {
            const value = get(values, name);
            const isOpen = value?.[`d${index}`]?.isOpen ?? false;

            return (
              <>
                <Grid alignContent={"center"} size={1}>
                  <Typography>
                    {moment()
                      .isoWeekday(index + 1)
                      .format("dddd")}
                  </Typography>
                </Grid>
                <Grid
                  display="flex"
                  alignItems={"center"}
                  justifyContent={"flex-end"}
                  size={1}
                >
                  <CheckboxField
                    name={`${name}.d${index}.isOpen`}
                    label={"Open"}
                    disabled={disabled}
                    indeterminate={false}
                    onChange={async (_, checked) => {
                      await setFieldValue(`${name}.d${index}.isOpen`, checked);
                      if (!checked) {
                        await setFieldValue(`${name}.d${index}.from`, null);
                        await setFieldValue(`${name}.d${index}.to`, null);
                      }
                    }}
                  />
                </Grid>
                <Grid alignContent={"center"} size={1}>
                  <TimePickerField
                    name={`${name}.d${index}.from`}
                    label={t("From")}
                    disabled={!isOpen || disabled}
                    required={isOpen}
                  />
                </Grid>
                <Grid alignContent={"center"} size={1}>
                  <TimePickerField
                    name={`${name}.d${index}.to`}
                    label={t("To")}
                    disabled={!isOpen || disabled}
                    required={isOpen}
                  />
                </Grid>
              </>
            );
          })}
      </Grid>
    </Box>
  );
};
